<div class="relative flex flex-col min-w-0 break-words w-full">

    <list-utils-bar (valueChanged)="onSearchTermChange($event)" [isSearching]="isSearching$"
        [showingResults]="showingSearchResults$" (onSearch)="onSearch($event)" (onCancel)="onCancelSearch()"
        (onRefresh)="onRefresh()"></list-utils-bar>

    @let loading = (loading$ | async);
    @let isSearching = (isSearching$ | async);
    @let showingSearchResults = (showingSearchResults$ | async);

    @for (item of members$ | async; track $index) {
    <div #itemRef [attr.data-id]="item.id"
        class="bg-white shadow-lg rounded w-full p-4 mb-4 flex flex-row justify-between transition-colors duration-1000"
        [class.bg-yellow-400]="item.id === firstNewItemId">
        <div class="flex flex-row items-start flex-nowrap cursor-pointer">
            @if (item.photoURL) {
            <img [src]="item.photoURL"
                class="bg-gray-100 min-h-10 max-h-10 max-w-10 min-w-10 object-cover rounded-full border-none" />
            } @else {
            <div
                class="bg-primary-100 uppercase text-primary-500 text-base flex justify-center items-center text-center min-h-10 max-h-10 max-w-10 min-w-10 rounded-full">
                {{ item?.name | initials }}
            </div>
            }
            <div class="flex flex-col px-3">
                <span class="text-sm font-bold text-primary-500">{{item.name ?? 'Name Unknown' | titlecase }}</span>
                <span class="text-xs text-primary-300">{{item.email ?? 'Email Unknown'}}</span>
            </div>
        </div>
        <div class="flex flex-row gap-2 whitespace-nowrap">
            <app-btn-fab (click)="onAssignRole(item)" icon="fas fa-id-card-clip" tooltip="Assign Role"></app-btn-fab>
            <app-change-member-status [item]="item"></app-change-member-status>
        </div>
    </div>
    } @empty {
    @if(!loading) {
    <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
        No Parents Found
    </div>
    }
    }
    @if(loading) {
    <loading-member></loading-member>
    }
</div>
@if (!(isSearching || showingSearchResults)) {
<div class="flex flex-row w-full justify-center px-4 mb-4 -mt-2">
    <app-btn-more (click)="addMore()" [isDisabled]="(loading$ | async) ?? false"></app-btn-more>
</div>
}